<script lang="ts">
    import {AcDropdown} from "ACUi/acui-dropdown";
    import {calculateColumn} from "../ajax/calculate";
    import {ColumnMetricConfig} from "../index";
    import {AcLoading} from "ACUi/element";
    import MetricMenu from "./MetricMenu.svelte";
    import {getMetricDisplayLabel} from "../utils";
    import {onMount} from "svelte";

    export let column: ColumnMetricConfig;

    let dropdown: AcDropdown | null;
    let loading: boolean = false;
    let result: string | null = null;
    let calculationType: string | null;

    const calculate = (aggregationType: string) => {
        calculationType = aggregationType || null;

        dropdown?.close();

        loading = true;

        calculateColumn(column.id, aggregationType).then(r => {
            result = r.data.result;
        }).finally(() => {
            loading = false;
        });
    }

    const handleClick = (e: CustomEvent<{ key: string }>) => {
        calculate(e.detail?.key);
    }

    onMount(() => {
        if (column.preference) {
            calculate(column.preference);
        }
    });

</script>


<AcDropdown
		appendToBody
		closeOnClick={true}
		menuClass="acp-metric-menu"
		position="top-right"
		bind:this={dropdown}
>
		<span slot="trigger"
				class="acp-metric-badge acu-cursor-pointer acu-flex acu-place-items-center acu-gap-1 acu-relative">
			{#if !result && !loading }
				<span class="acu-text-[12px] acu-uppercase acu-font-medium">Calculate</span>
			{:else if loading}
				<AcLoading size="small"/>
			{:else}
				<span class="acp-metric-badge__type acu-uppercase acu-font-medium">{getMetricDisplayLabel( calculationType, column.metrics )}</span>
				<span class="acp-metric-badge__result acu-font-bold acu-text-[#000]">{@html result}</span>
			{/if}
		</span>
	<MetricMenu metrics={column.metrics} on:click={handleClick}/>

</AcDropdown>
